<template>
    <div class="temp2">
        temp2
    </div>
</template>
<script>
    export default{
        name:'temp2',
        data(){
            return {}
        }
    }
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/main-content/router-test/temp2.vue